import cartService, { getCartId, getOrderId, setCartId, setOrderId } from "../../services/cartService";
import cmsBlockService from "../../services/cmsBlockService";
import currencyService from "../../services/currencyService";
import packageService from "../../services/packageService";
import storeConfigService from "../../services/storeConfigService";
import categoryInfoService from "../../services/categoryInfo";

import { CartState } from "../../utils/interfaces/cart";
import {
  CategoryItemState,
  CategoryState,
} from "../../utils/interfaces/categoryInfo";
import { CmsBlocksDataState } from "../../utils/interfaces/cmsBlock";
import { CurrencyState } from "../../utils/interfaces/currency";
import { PackageState } from "../../utils/interfaces/packages";
import { PaymentFrequencyState, StoreConfigState } from "../../utils/interfaces/storelogo";
import { cmsBlockKeys, productKey } from "../../utils/constants";
import { mtm_getUtmParamsFromSession, mtm_hasSpecialOfferCampaign } from "../../utils/utility";

export const layoutQueries = async (
  loading: any,
  setLoading: (loading: any) => void,
  setFooter: (res: CmsBlocksDataState) => void,
  setCurrency: (res: CurrencyState) => void,
  setStoreConfig: (res: StoreConfigState) => void,
  setPaymentFrequencyConfig: (res: PaymentFrequencyState) => void
) => {
  let temploading = { ...loading };
  //cmsblock apis
  await cmsBlockService.setCMSBlocks(cmsBlockKeys.footer, setFooter, () => {
    temploading.footer = false;
    setLoading(temploading);
  });
  // Get Faq Data
  await currencyService.setCurrency(setCurrency, () => {
    temploading.currency = false;
    setLoading(temploading);
  });
  // Get Store Config Data
  await storeConfigService.setStoreConfig(setStoreConfig, () => {
    temploading.storeConfig = false;
    setLoading(temploading);
  });

  await storeConfigService.setPaymentFrequencyConfig(setPaymentFrequencyConfig, () => {
    temploading.paymentFrequencyConfig = false;
    setLoading(temploading);
  });
};

export const manageCartData = async (
  loading: any,
  setLoading: (loading: any) => void,
  setCart: (res: CartState) => void
) => {
  let temploading = { ...loading };
  // Get Cart Data
  await cartService
    .checkisUserAuth(getCartId() || "")
    .then(async (resp: any) => {
      if (resp.length > 0) {
        await cartService.setCartData(resp, setCart, () => {
          temploading.cart = false;
          setLoading(temploading);
        });
      } else {
        let orderId = getOrderId();
        if(orderId) setOrderId("");
        await cartService.createEmptyCart().then(async (res: any) => {
          if (res) {
            await cartService.setCartData(res.cartId, setCart, () => {
              temploading.cart = false;
              setLoading(temploading);
            });
            setCartId(res.cartId);
          }
        });
      }
    })
    .catch(async (e: Error) => {
      let orderId = getOrderId();
      if(orderId) setOrderId("");
      await cartService.createEmptyCart().then(async (res: any) => {
        if (res) {
          await cartService.setCartData(res.cartId, setCart, () => {
            temploading.cart = false;
            setLoading(temploading);
          });
          setCartId(res.cartId);
        }
      });
    });
};

const findByUid = (obj: any, categoryName: string) => {
  let stack = [obj];
  while (stack.length > 0) {
    let node = stack.pop();
    for (let key in node) {
      if (node[key] && typeof node[key] === "object") {
        if (node[key]?.name === categoryName) {
          return node[key];
        } else {
          stack.push(node[key]);
        }
      }
    }
  }
  return null;
};

export const packageQueries = async (
  loading: any,
  setLoading: (loading: any) => void,
  setBundlePackages: (res: PackageState) => void,
  setVirtualPackages: (res: PackageState) => void,
  setCategory: (res: CategoryItemState) => void
) => {
  let temploading = { ...loading };
  // Get Category Data
  await categoryInfoService
    .fetchRootCategoryId()
    .then(async (res: any) => {
      if (res) {
        setCategory(res);
        let bundleProductId = "";
        let virtualProductId = "";
        
        if (res?.items?.length) {
          const hasSpecialOffer = mtm_hasSpecialOfferCampaign();
 
          res.items.forEach((item: CategoryState) => {
            bundleProductId =  (hasSpecialOffer ? findByUid(item, productKey.discounted_products_category_name)?.uid : "") || 
            findByUid(item, productKey.bundle_products_category_name)?.uid || "";
            virtualProductId = findByUid(item, productKey.addon_category_name)?.uid  ;
          });
        }

        await packageService.setPackages(
          bundleProductId,
          setBundlePackages,
          () => {
            temploading.bundlePackage = false;
            setLoading(temploading);
          }
        );
        await packageService.setPackages(
          virtualProductId,
          setVirtualPackages,
          () => {
            temploading.virtualPackage = false;
            setLoading(temploading);
          }
        );
      }
      temploading.categoryInfo = false;
      setLoading(temploading);
    })
    .catch((e: Error) => {
      // add error handling
    });
};
